export const Cultures = () => {
  return {
    euCulture: {
      decimalPlaces: 2,
      currencySymbol: "€",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    gbCulture: {
      decimalPlaces: 2,
      currencySymbol: "£",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    usCulture: {
      decimalPlaces: 2,
      currencySymbol: "$",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    dkCulture: {
      decimalPlaces: 2,
      currencySymbol: "kr.",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    caCulture: {
      decimalPlaces: 2,
      currencySymbol: "$",
      decimalCharacter: ".",
      digitGroupSeparator: ","
    },
    cnCulture: {
      decimalPlaces: 2,
      currencySymbol: "¥",
      decimalCharacter: ".",
      digitGroupSeparator: ","
    },
    huCulture: {
      decimalPlaces: 2,
      currencySymbol: "Ft",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    czCulture: {
      decimalPlaces: 2,
      currencySymbol: "Kč",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    },
    noCulture: {
      decimalPlaces: 2,
      currencySymbol: "kr",
      decimalCharacter: ".",
      digitGroupSeparator: ","
    },
    plCulture: {
      decimalPlaces: 2,
      currencySymbol: "zł",
      decimalCharacter: ",",
      digitGroupSeparator: "."
    }
  };
};
